import { UserFilters } from "../types/UserFilters";
import { USER_TYPE_OPTION_ANY } from "../types/UserTypeOptions";

export enum TypeKeys {
    CLEAR_FILTERS = "USER/CLEAR_FILTERS",
    SET_ACTIVE_FILTERS = "USER/SET_ACTIVE_FILTERS",
    SET_TEXT_FILTER = "USER/SET_TEXT_FILTER",
}
export const createAction = {
    clearFilters: () => ({ type: TypeKeys.CLEAR_FILTERS }),
    setFilters: (filters: UserFilters) => ({ type: TypeKeys.SET_ACTIVE_FILTERS, filters }),
    setTextFilter: (text: string) => ({ type: TypeKeys.SET_TEXT_FILTER, text }),
};

type ClearFiltersAction = { type: TypeKeys.CLEAR_FILTERS };
type SetActiveFiltersAction = { type: TypeKeys.SET_ACTIVE_FILTERS; filters: UserFilters };
type SetFilterTextAction = { type: TypeKeys.SET_TEXT_FILTER; text: string };

type FilterAction = ClearFiltersAction | SetActiveFiltersAction | SetFilterTextAction;

export interface State {
    active: UserFilters;
    text: string;
}

export function getInitialState(): State {
    return {
        active: {
            teamRoles: [],
            appRoles: [],
            access: [],
            userType: USER_TYPE_OPTION_ANY,
        },
        text: "",
    };
}

export function reducer(state: State = getInitialState(), action: FilterAction): State {
    if (action.type === TypeKeys.CLEAR_FILTERS) {
        return getInitialState();
    }

    if (action.type === TypeKeys.SET_ACTIVE_FILTERS) {
        const { filters } = action;

        return {
            ...state,
            active: filters,
        };
    }

    if (action.type === TypeKeys.SET_TEXT_FILTER) {
        const { text } = action;

        return {
            ...state,
            text,
        };
    }

    return state;
}
